<template>
  <div class="w-full sm:max-w-368 px-16 sm:px-0">
    <slot />
    <div class="category-form mt-56">
      <h1 class="text-h3">What's the theme of your Adventure?</h1>
      <ul class="mt-24">
        <li v-for="category in categories" :key="category.id">
          <Card
            :id="`${category.id}`"
            :value="category.name"
            :clickable="true"
            :elevation="3"
            class="w-full mb-16 relative"
            @click="setAdventureCategory"
          >
            <span class="text-strong-body">
              {{ category.name }}
            </span>
            <div class="absolute h-full flex items-center justify-center right-0 top-0 pr-20">
              <DisclosureIcon :width="16" :height="16" /></div
          ></Card>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import DisclosureIcon from '@/graphics/icons/DisclosureIcon.vue';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'Category',
  components: { Card, DisclosureIcon },
  props: {
    allCategories: {
      default: () => {},
      type: [Object],
    },
    adventureMetaData: {
      default: () => {},
      type: Object,
    },
    account: {
      default: () => {},
      type: Object,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    categories(): any {
      return this.allCategories?.categories;
    },
  },
  mounted() {
    this.trackAdventureStarted();
  },
  methods: {
    async setAdventureCategory({ currentTarget }) {
      if (Number(currentTarget.id) !== Number(this.$store.getters['adventures/adventureDraft'].adventureCategoryId)) {
        await this.$store.dispatch('adventures/updatePending', {
          adventureCategoryImage: null,
          adventureCategoryId: Number(currentTarget.id),
          adventureCategoryName: currentTarget.value,
        });
      }
      // Edit Category needs to route to Photo because each category has different photos
      this.$router.push({
        path: this.isEdit
          ? `/adventures/${this.$store.getters['adventures/adventureId']}/edit/photo`
          : '/adventures/new/age_range',
      });
    },
    trackAdventureStarted() {
      const date = new Date().toLocaleString('default', { month: 'long', day: 'numeric', year: 'numeric' });
      const id = this.account?.id;

      sendSegmentEvent('Adventure Started', {
        started_date: date,
        user_id: id,
      });
    },
  },
};
</script>

<style scoped>
.breadcrumb + .category-form {
  margin-top: 24px;
}
</style>
